import api from './api';

export const getBusinessRoleAssignments = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/role-assignments`, { params });

export const createRoleAssignment = (businessId, data) =>
  api.post(`/businesses/${businessId}/role-assignments`, data);

export const revokeRoleAssignment = (businessId, assignmentId) =>
  api.delete(`/businesses/${businessId}/role-assignments/${assignmentId}`);
